module.exports = __webpack_public_path__ + "img/video_bg@3x.27571a47.jpg";